import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    paddingBottom: 10,
    borderWidth: 1,
    borderRadius: 5,
  },
  actionButton: {
    marginHorizontal: 10,
    borderRadius: 50,
    marginTop: 20,
  },
  imageContainer: {
    marginHorizontal: 10,
    marginTop: 15,
  },
  allContainer: {justifyContent: 'flex-end'},
  accordionStyle: {
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderTopWidth: 1,
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  headerStyle: {marginHorizontal: 10, marginTop: 10},
  addContainer: {
    justifyContent: 'center',
    borderWidth: 1,
    borderRadius: 50,
    marginTop: 5,
    paddingVertical: 2,
  },
  addText: {
    marginLeft: 10,
  },
  externalPillcontainer: {
    paddingVertical: 2,
  },
});
